import Image, { StaticImageData } from "next/image";
import Peter from "public/assets/headshots/peter.png";
import Raza from "public/assets/headshots/raza.png";
import Jordan from "public/assets/headshots/jordan.png";
import David from "public/assets/headshots/david.png";
import Emine from "public/assets/headshots/emine.png";
import George from "public/assets/headshots/george.png";
import Harry from "public/assets/headshots/harry.png";
import Button from "@components/library/Button";
import { CAREERS_LINK } from "utils/constants";
import { ExternalLinkIcon } from "@heroicons/react/outline";

const MeetTheTeam = () => {
  return (
    <div className="bg-black">
      <div className="container-xl">
        <div className="grid grid-cols-1 gap-x-40 gap-y-24 pb-40 sm:grid-cols-2 md:grid-cols-3 md:gap-y-80 md:gap-x-40 md:px-120 md:pt-120 md:pb-160">
          <div>
            <div className="mb-16 mt-48 font-display text-24-32 font-bold text-gray-400">
              Meet the team
            </div>
            <div className=" mb-12 text-14-22 text-gray-400">
              Our team have previously worked on some of the largest AI projects
              at Google, Microsoft and Amazon. We&apos;re backed by some of the
              world&apos;s top investors including Index Ventures and Y
              Combinator
            </div>
            <Button
              className="mt-32 bg-white"
              IconRight={ExternalLinkIcon}
              href={CAREERS_LINK}
              styling="solid"
            >
              View open positions
            </Button>
          </div>
          <div className="hidden py-48 sm:block md:col-span-2" />
          {teamMembers.map((teamMember) => (
            <TeamMember key={teamMember.name} {...teamMember} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default MeetTheTeam;

const teamMembers: TeamMemberProps[] = [
  {
    name: "Raza Habib",
    title: "Cofounder & CEO",
    description:
      "Ex-MonolithAI and Google. ML PhD @ UCL and MSc in Physics @ Cambridge.",
    imageSrc: Raza,
  },
  {
    name: "Jordan Burgess",
    title: "Cofounder",
    description:
      "Previously at Amazon Alexa Research. ML MPhil @ Cambridge and CS @ MIT.",
    imageSrc: Jordan,
  },
  {
    name: "Peter Hayes",
    title: "Cofounder",
    description: "Previously cofounder @ Certua. ML PhD @ UCL.",
    imageSrc: Peter,
  },
  {
    name: "David Barber",
    title: "Cofounder & Research",
    description:
      "Director of UCL's AI Center and previously cofounder @ Re:infer.",
    imageSrc: David,
  },
  {
    name: "Emine Yilmaz",
    title: "Cofounder & Research",
    description: "Professor at UCL, Turing Fellow, Amazon Scholar.",
    imageSrc: Emine,
  },
  {
    name: "Harry Xie",
    title: "Product",
    description:
      "Previously worked on conversational AI at Chai. MSci Physics @ Imperial.",
    imageSrc: Harry,
  },
  {
    name: "George Seabridge",
    title: "Product",
    description:
      "Previously worked in banking and finance. BA Mathematics @ Cambridge.",
    imageSrc: George,
  },
];

interface TeamMemberProps {
  name: string;
  title: string;
  description: string;
  imageSrc: StaticImageData;
}

const TeamMember = ({
  name,
  title,
  description,
  imageSrc,
}: TeamMemberProps) => {
  return (
    <div className="flex flex-row gap-x-12 sm:flex-col">
      <div className="block aspect-square min-h-[96px]">
        <Image
          src={imageSrc}
          alt={`Portrait of ${name}`}
          sizes="100vw"
          style={{
            width: "346px",
            height: "auto",
          }}
        />
      </div>
      <div className="basis-[500px] sm:basis-0">
        <div className="text-14-16 font-bold text-white sm:mt-24 sm:text-16-24">
          {name}
        </div>
        <div className="mt-6 text-12-14 text-gray-600 sm:mt-8 sm:text-14-16">
          {title}
        </div>
        <div className="text-12-24 sm:mt-14 mt-8 text-gray-400 sm:text-14-22">
          {description}
        </div>
      </div>
    </div>
  );
};
